import React from 'react';
import { Search, Copy } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const STEPS = [
  'Go to search.google.com/search-console and sign in with your Google account.',
  'Click "Add property". Once you have your own domain, pick "Domain" and follow the steps your domain provider shows (one-time).',
  'Until then, pick "URL prefix", paste your website address, and choose the "HTML tag" option. Send that code to your website builder so it can be added to the site.',
  'After it says "Verified", open "Sitemaps" on the left, paste the sitemap address below and press Submit.',
  'Every time you publish an article, Google will find it through the sitemap automatically.',
];

export const AdminSearchSetup = () => {
  const { toast } = useToast();
  const sitemap = `${window.location.origin}/api/sitemap.xml`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(sitemap); toast({ title: 'Sitemap address copied' }); }
    catch { toast({ title: 'Copy failed, select it manually', variant: 'destructive' }); }
  };
  return (
    <section data-testid="admin-search-setup-section" className="pb-20 max-w-[1200px] mx-auto px-8">
      <p className="text-[11px] tracking-[0.3em] text-[#8B7FB8] font-medium mb-3 flex items-center gap-2"><Search size={13} /> GOOGLE SEARCH</p>
      <h2 className="font-serif text-4xl text-[#1E1B18] mb-6">Get found on Google</h2>
      <div className="bg-[#FBF7F0] border border-[#1E1B18]/8 rounded-sm p-6">
        <ol className="list-decimal pl-5 space-y-2 text-[14px] text-[#1E1B18]/75">
          {STEPS.map((s) => <li key={s}>{s}</li>)}
        </ol>
        <div className="mt-6 flex flex-col sm:flex-row gap-2 sm:items-center">
          <code data-testid="admin-sitemap-url" className="flex-1 min-w-0 break-all bg-[#F4EFE7] border border-[#1E1B18]/10 rounded-sm px-4 py-2.5 text-[13px]">{sitemap}</code>
          <button data-testid="admin-copy-sitemap-btn" onClick={copy}
            className="inline-flex items-center justify-center gap-2 border border-[#1E1B18]/20 hover:border-[#1E1B18]/50 px-4 py-2.5 rounded-full text-[12px] font-medium transition-colors">
            <Copy size={13} /> Copy
          </button>
        </div>
      </div>
    </section>
  );
};
